import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": "80%"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer --t-2"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Scheduled logistic costs modifications")])]), _c(VCardText, [_c(VExpansionPanels, {
    attrs: {
      multiple: ""
    },
    model: {
      value: _vm.openedPanels,
      callback: function callback($$v) {
        _vm.openedPanels = $$v;
      },
      expression: "openedPanels"
    }
  }, [_c(VExpansionPanel, {
    staticClass: "rounded",
    attrs: {
      "active-class": "rounded"
    }
  }, [_c(VExpansionPanelHeader, [_c("div", {
    staticClass: "text-bold"
  }, [_vm._v("Schedule a new modification")])]), _c(VExpansionPanelContent, [_c("div", {
    staticClass: "add-content"
  }, [_c("div", [_c("div", [_vm._v("Modifications type")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.modificationTypesEnum,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "name",
      rules: [_vm.rules.mustSelectValue]
    },
    on: {
      change: function change($event) {
        return _vm.changeModificationType();
      }
    },
    model: {
      value: _vm.form.modificationType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "modificationType", $$v);
      },
      expression: "form.modificationType"
    }
  })], 1), _c("div", [_c("div", {
    staticClass: "required"
  }, [_vm._v("Application date")]), _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          staticClass: "v-text-field-no-label",
          attrs: {
            type: "date",
            required: "",
            rules: [_vm.rules.mustNotBeEmpty],
            "hide-details": "auto"
          },
          model: {
            value: _vm.form.scheduledApplicationDate,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "scheduledApplicationDate", $$v);
            },
            expression: "form.scheduledApplicationDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.addDateMenu,
      callback: function callback($$v) {
        _vm.addDateMenu = $$v;
      },
      expression: "addDateMenu"
    }
  }, [_c(VDatePicker, {
    attrs: {
      min: _vm.minDate
    },
    on: {
      input: function input($event) {
        _vm.addDateMenu = false;
      }
    },
    model: {
      value: _vm.form.scheduledApplicationDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "scheduledApplicationDate", $$v);
      },
      expression: "form.scheduledApplicationDate"
    }
  })], 1)], 1), _vm.form.modificationType === _vm.modificationTypesEnum.find(function (x) {
    return x.constant === "CALCULATIONS";
  }).id ? [_c("div", [_c("div", {
    staticClass: "required"
  }, [_vm._v("Rate modification (%)")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "0.00",
      type: "number",
      required: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.modificationPercentageEurPerBottle,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "modificationPercentageEurPerBottle", $$v);
      },
      expression: "form.modificationPercentageEurPerBottle"
    }
  })], 1), _c("div", [_c("div", {
    staticClass: "required"
  }, [_vm._v("Price modification/btl (+/- €)")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "0.00",
      type: "number",
      required: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.modificationAddEurPerBottle,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "modificationAddEurPerBottle", $$v);
      },
      expression: "form.modificationAddEurPerBottle"
    }
  })], 1)] : [_c("div", [_c("div", {
    staticClass: "required"
  }, [_vm._v("Future price/btl (€)")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "0.00",
      type: "number",
      min: "0.01",
      rules: [_vm.rules.mustBeGreaterThan0],
      required: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.futureShippingPriceEurPerBottle,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "futureShippingPriceEurPerBottle", $$v);
      },
      expression: "form.futureShippingPriceEurPerBottle"
    }
  })], 1)]], 2), _c("div", {
    staticClass: "add-content mt-4"
  }, [_c("div", [_c("div", [_vm._v("Shipping type(s)")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.derivedExpeditionMethods,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "text",
      label: _vm.form.expeditionMethods.length === 0 ? "All" : "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      clearable: ""
    },
    model: {
      value: _vm.form.expeditionMethods,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "expeditionMethods", $$v);
      },
      expression: "form.expeditionMethods"
    }
  })], 1), _c("div", [_c("div", [_vm._v("User group")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label v-min-height-select-chips",
    attrs: {
      items: _vm.derivedUserGroups,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "name",
      label: !_vm.form.userGroup ? "All" : "",
      clearable: ""
    },
    model: {
      value: _vm.form.userGroup,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "userGroup", $$v);
      },
      expression: "form.userGroup"
    }
  })], 1), _c("div", [_c("div", {
    staticClass: "required"
  }, [_vm._v("Arrival(s)")]), _c("MultipleCountryStatesSelector", {
    attrs: {
      disabled: _vm.form.exceptionArrivals.length > 0,
      countries: _vm.derivedCountriesArrival,
      isHorecaIncludedInUserGroup: _vm.isHorecaIncludedInUserGroup,
      containsForbiddenStates: _vm.containsForbiddenStates
    },
    on: {
      valueChanged: _vm.changeArrivals
    }
  })], 1), _c("div", [_c("div", {
    staticClass: "required"
  }, [_vm._v("All arrivals excepted")]), _c("MultipleCountryStatesSelector", {
    attrs: {
      disabled: _vm.form.arrivals.length > 0,
      countries: _vm.derivedCountriesArrival,
      isHorecaIncludedInUserGroup: _vm.isHorecaIncludedInUserGroup,
      containsForbiddenStates: _vm.containsForbiddenStates,
      titleAll: "No exceptions"
    },
    on: {
      valueChanged: _vm.changeExceptionArrivals
    }
  })], 1), _c("div", [_c("div", {
    staticClass: "required"
  }, [_vm._v("Departure(s)")]), _c("MultipleCountryStatesSelector", {
    attrs: {
      disabled: _vm.form.exceptionDepartures.length > 0,
      countries: _vm.derivedCountries
    },
    on: {
      valueChanged: _vm.changeDepartures
    }
  })], 1), _c("div", [_c("div", {
    staticClass: "required"
  }, [_vm._v("All departures excepted")]), _c("MultipleCountryStatesSelector", {
    attrs: {
      disabled: _vm.form.departures.length > 0,
      countries: _vm.derivedCountries,
      titleAll: "No exceptions"
    },
    on: {
      valueChanged: _vm.changeExceptionDepartures
    }
  })], 1)]), _c("div", {
    staticClass: "flex justify-end mt-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      disabled: _vm.isInvalidForm || _vm.isHorecaIncludedInUserGroup && _vm.containsForbiddenStates,
      loading: _vm.isAdding
    },
    on: {
      click: function click($event) {
        return _vm.save();
      }
    }
  }, [_c("i", {
    staticClass: "far fa-calendar-alt mr-1"
  }), _vm._v(" Schedule ")])], 1)])], 1), _vm.futureScheduledModifications.length > 0 ? _c(VExpansionPanel, {
    staticClass: "rounded",
    attrs: {
      "active-class": "rounded"
    }
  }, [_c(VExpansionPanelHeader, [_c("div", {
    staticClass: "text-bold"
  }, [_vm._v(" " + _vm._s("Scheduled modifications (".concat(_vm.futureScheduledModifications.length, ")")) + " ")])]), _c(VExpansionPanelContent, [_c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      headers: _vm.futureHeaders,
      items: _vm.futureScheduledModifications,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.scheduledApplicationDate",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate_string")(item.scheduledApplicationDate)) + " ")])];
      }
    }, {
      key: "item.expeditionMethods",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.expeditionMethods.length === 0 ? _c("div", [_vm._v("All")]) : _vm._l(item.expeditionMethods, function (expeditionMethod, index) {
          return _c("div", {
            key: "future-expeditionMethod-" + item.id + "-" + index
          }, [_vm._v(" · " + _vm._s(_vm.expeditionMethodList.find(function (x) {
            return x.id === expeditionMethod;
          }).text) + " ")]);
        })];
      }
    }, {
      key: "item.arrivalLocations",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c("div", [item.arrivals.length > 0 ? _vm._l(item.arrivals, function (location) {
          var _location$state;
          return _c("div", {
            key: "future-arrivalLocation-" + item.id + "-" + location.id
          }, [_vm._v(" · " + _vm._s(location.country.name + ((_location$state = location.state) !== null && _location$state !== void 0 && _location$state.name ? ", " + location.state.name : "")) + " ")]);
        }) : item.exceptionArrivals.length > 0 ? [_c("div", {
          staticClass: "text-smaller text-underline"
        }, [_vm._v("All except :")]), _vm._l(item.exceptionArrivals, function (location) {
          var _location$state2;
          return _c("div", {
            key: "future-exceptionArrivalsLocation-" + item.id + "-" + location.id
          }, [_vm._v(" · " + _vm._s(location.country.name + ((_location$state2 = location.state) !== null && _location$state2 !== void 0 && _location$state2.name ? ", " + location.state.name : "")) + " ")]);
        })] : [_vm._v("All")]], 2)];
      }
    }, {
      key: "item.departureLocations",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c("div", [item.departures.length > 0 ? _vm._l(item.departures, function (location) {
          var _location$state3;
          return _c("div", {
            key: "future-departureLocation-" + item.id + "-" + location.id
          }, [_vm._v(" · " + _vm._s(location.country.name + ((_location$state3 = location.state) !== null && _location$state3 !== void 0 && _location$state3.name ? ", " + location.state.name : "")) + " ")]);
        }) : item.exceptionDepartures.length > 0 ? [_c("div", {
          staticClass: "text-smaller text-underline"
        }, [_vm._v("All except :")]), _vm._l(item.exceptionDepartures, function (location) {
          var _location$state4;
          return _c("div", {
            key: "future-exceptionDepartureLocation-" + item.id + "-" + location.id
          }, [_vm._v(" · " + _vm._s(location.country.name + ((_location$state4 = location.state) !== null && _location$state4 !== void 0 && _location$state4.name ? ", " + location.state.name : "")) + " ")]);
        })] : [_vm._v("All")]], 2)];
      }
    }, {
      key: "item.userGroup",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c("div", [_vm._v(" " + _vm._s(item.userGroup ? _vm.listUserGroups.find(function (x) {
          return x.id === item.userGroup;
        }).name : "All") + " ")])];
      }
    }, {
      key: "item.modifications",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c("div", [item.modificationType === _vm.modificationTypesEnum.find(function (x) {
          return x.constant === "CALCULATIONS";
        }).id ? _c("div", [item.modificationPercentageEurPerBottle ? _c("div", [_vm._v(" " + _vm._s((item.modificationPercentageEurPerBottle > 0 ? "+" : "") + item.modificationPercentageEurPerBottle + " %") + " ")]) : _vm._e(), item.modificationAddEurPerBottle ? _c("div", [_vm._v(" " + _vm._s((item.modificationAddEurPerBottle > 0 ? "+" : "") + item.modificationAddEurPerBottle + " €/btl") + " ")]) : _vm._e()]) : item.modificationType === _vm.modificationTypesEnum.find(function (x) {
          return x.constant === "DEFINITION";
        }).id ? [_c("div", {
          staticClass: "text-smaller text-underline"
        }, [_vm._v("New price :")]), _c("div", [_vm._v(_vm._s(item.futureShippingPriceEurPerBottle + " €/btl"))])] : _vm._e()], 2)];
      }
    }, {
      key: "item.action",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [_c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            title: "Cancel",
            rounded: "",
            disabled: item.isDeleting || _vm.isDeletingAll
          },
          on: {
            click: function click($event) {
              return _vm.confirmCancelScheduledModification(item);
            }
          }
        }, [_c("i", {
          staticClass: "fas fa-trash"
        })])], 1)];
      }
    }], null, true)
  }), _c("div", {
    staticClass: "mt-2 flex justify-end"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      title: "Cancel all",
      rounded: "",
      disabled: _vm.isDeletingAll || _vm.futureScheduledModifications.some(function (x) {
        return x.isDeleting;
      })
    },
    on: {
      click: function click($event) {
        return _vm.confirmCancelAllFutureModifications();
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-trash"
  }), _vm._v(" CANCEL ALL ")])], 1)], 1)], 1) : _vm._e(), _vm.previousScheduledModifications.length > 0 ? _c(VExpansionPanel, {
    staticClass: "rounded",
    attrs: {
      "active-class": "rounded"
    }
  }, [_c(VExpansionPanelHeader, [_c("div", {
    staticClass: "text-bold"
  }, [_vm._v(" " + _vm._s("History (".concat(_vm.previousScheduledModifications.length, ")")) + " ")])]), _c(VExpansionPanelContent, [_c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      headers: _vm.previousHeaders,
      items: _vm.previousScheduledModifications,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.actualApplicationDate",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate_string")(item.actualApplicationDate)) + " ")])];
      }
    }, {
      key: "item.expeditionMethods",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return [item.expeditionMethods.length === 0 ? _c("div", [_vm._v("All")]) : _vm._l(item.expeditionMethods, function (expeditionMethod, index) {
          return _c("div", {
            key: "future-expeditionMethod-" + item.id + "-" + index
          }, [_vm._v(" · " + _vm._s(_vm.expeditionMethodList.find(function (x) {
            return x.id === expeditionMethod;
          }).text) + " ")]);
        })];
      }
    }, {
      key: "item.arrivalLocations",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_c("div", [item.arrivals.length > 0 ? _vm._l(item.arrivals, function (location) {
          var _location$state5;
          return _c("div", {
            key: "future-arrivalLocation-" + item.id + "-" + location.id
          }, [_vm._v(" · " + _vm._s(location.country.name + ((_location$state5 = location.state) !== null && _location$state5 !== void 0 && _location$state5.name ? ", " + location.state.name : "")) + " ")]);
        }) : item.exceptionArrivals.length > 0 ? [_c("div", {
          staticClass: "text-smaller text-underline"
        }, [_vm._v("All except :")]), _vm._l(item.exceptionArrivals, function (location) {
          var _location$state6;
          return _c("div", {
            key: "future-exceptionArrivalsLocation-" + item.id + "-" + location.id
          }, [_vm._v(" · " + _vm._s(location.country.name + ((_location$state6 = location.state) !== null && _location$state6 !== void 0 && _location$state6.name ? ", " + location.state.name : "")) + " ")]);
        })] : [_vm._v("All")]], 2)];
      }
    }, {
      key: "item.departureLocations",
      fn: function fn(_ref12) {
        var item = _ref12.item;
        return [_c("div", [item.departures.length > 0 ? _vm._l(item.departures, function (location) {
          var _location$state7;
          return _c("div", {
            key: "future-departureLocation-" + item.id + "-" + location.id
          }, [_vm._v(" · " + _vm._s(location.country.name + ((_location$state7 = location.state) !== null && _location$state7 !== void 0 && _location$state7.name ? ", " + location.state.name : "")) + " ")]);
        }) : item.exceptionDepartures.length > 0 ? [_c("div", {
          staticClass: "text-smaller text-underline"
        }, [_vm._v("All except :")]), _vm._l(item.exceptionDepartures, function (location) {
          var _location$state8;
          return _c("div", {
            key: "future-exceptionDepartureLocation-" + item.id + "-" + location.id
          }, [_vm._v(" · " + _vm._s(location.country.name + ((_location$state8 = location.state) !== null && _location$state8 !== void 0 && _location$state8.name ? ", " + location.state.name : "")) + " ")]);
        })] : [_vm._v("All")]], 2)];
      }
    }, {
      key: "item.userGroup",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return [_c("div", [_vm._v(" " + _vm._s(item.userGroup ? _vm.listUserGroups.find(function (x) {
          return x.id === item.userGroup;
        }).name : "All") + " ")])];
      }
    }, {
      key: "item.modifications",
      fn: function fn(_ref14) {
        var item = _ref14.item;
        return [_c("div", [item.modificationType === _vm.modificationTypesEnum.find(function (x) {
          return x.constant === "CALCULATIONS";
        }).id ? _c("div", [item.modificationPercentageEurPerBottle ? _c("div", [_vm._v(" " + _vm._s((item.modificationPercentageEurPerBottle > 0 ? "+" : "") + item.modificationPercentageEurPerBottle + " %") + " ")]) : _vm._e(), item.modificationAddEurPerBottle ? _c("div", [_vm._v(" " + _vm._s((item.modificationAddEurPerBottle > 0 ? "+" : "") + item.modificationAddEurPerBottle + " €/btl") + " ")]) : _vm._e()]) : item.modificationType === _vm.modificationTypesEnum.find(function (x) {
          return x.constant === "DEFINITION";
        }).id ? [_c("div", {
          staticClass: "text-smaller text-underline"
        }, [_vm._v("New price :")]), _c("div", [_vm._v(_vm._s(item.futureShippingPriceEurPerBottle + " €/btl"))])] : _vm._e()], 2)];
      }
    }], null, true)
  })], 1)], 1) : _vm._e()], 1)], 1), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      loading: _vm.isLoading
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v(" Close ")])], 1)], 1), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };